<script lang="ts">
  import { link } from "svelte-spa-router";
  import { buttonVariants } from "$ui/button";

  export let title: string = "";
  export let label: string = "";
  export let href: string = "";
</script>

<div class="card p-5 pt-3 pb-5 flex-1 flex flex-col gap-2" {href} use:link>
  <div class="flex gap-3">
    <div class="flex-1 flex items-center gap-3">
      <h3 class="text-xl font-semibold flex-1">{title}</h3>
      <a {href} use:link class={buttonVariants({ variant: "link" })}>
        {label}
      </a>
    </div>
  </div>
  <div class="flex items-end">
    <div class="flex-1 flex items-start gap-3">
      <div class="text-5xl font-semibold">
        <slot />
      </div>
    </div>
    <div class="border-0 border-gray-200 rounded-lg [&>svg]:w-11 [&>svg]:h-11 [&>svg]:stroke-[1.5px] text-gray-300">
      <slot name="icon" />
    </div>
  </div>
</div>
